import { Component, inject, Optional } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { MediaModule, OutletModule, ProductListItemContext } from '@spartacus/storefront';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'custom-product-grid-item-detail',
  templateUrl: './product-grid-item-details.component.html',
  styleUrl: './product-grid-item-details.component.scss',
  imports: [CommonModule, MediaModule, RouterModule, I18nModule, UrlModule, OutletModule],
})
export class CustomProductGridItemDetailComponent {
  @Optional() protected productContext = inject(ProductListItemContext);

  product$ = this.productContext.product$;
}
